export function fromRelationshipLegalTerms(legalTermsArray) {
    return legalTermsArray.map((legalTerms)=>{
        switch(legalTerms.type){
            case 'pdf':
                return {
                    id: legalTerms.legalTermsId,
                    contentType: 'pdf',
                    origin: 'custom',
                    name: legalTerms.displayName,
                    pdfUniqueName: legalTerms.pdf.pdfName,
                    pdfFileName: legalTerms.pdf.pdfFileName,
                    defaultVersion: legalTerms.defaultVersion,
                    previousDefaultVersion: legalTerms.previousDefaultVersion
                };
            case 'richText':
                var _ref;
                var _legalTerms_richText;
                return {
                    id: legalTerms.legalTermsId,
                    contentType: 'richText',
                    origin: 'system',
                    name: legalTerms.displayName,
                    richTextId: (_ref = (_legalTerms_richText = legalTerms.richText) === null || _legalTerms_richText === void 0 ? void 0 : _legalTerms_richText.textId) !== null && _ref !== void 0 ? _ref : null,
                    richTextContent: [],
                    defaultVersion: legalTerms.defaultVersion,
                    previousDefaultVersion: legalTerms.previousDefaultVersion
                };
            case 'quill':
                var _ref1;
                var _legalTerms_quill;
                return {
                    id: legalTerms.legalTermsId,
                    contentType: 'quill',
                    origin: 'custom',
                    name: legalTerms.displayName,
                    richTextId: (_ref1 = (_legalTerms_quill = legalTerms.quill) === null || _legalTerms_quill === void 0 ? void 0 : _legalTerms_quill.textId) !== null && _ref1 !== void 0 ? _ref1 : null,
                    richTextContent: [],
                    defaultVersion: legalTerms.defaultVersion,
                    previousDefaultVersion: legalTerms.previousDefaultVersion
                };
        }
    });
}
export function toRelationshipLegalTermsDocuments(legalTerms, contentOverride) {
    switch(legalTerms.contentType){
        case 'pdf':
            return {
                type: 'pdf',
                displayName: legalTerms.name,
                legalTermsId: legalTerms.id,
                termsOfService: {
                    type: 'none'
                },
                pdf: {
                    pdfName: legalTerms.pdfUniqueName,
                    pdfFileName: legalTerms.pdfFileName
                }
            };
        case 'richText':
            return {
                type: 'richText',
                legalTermsId: legalTerms.id,
                displayName: legalTerms.name,
                termsOfService: {
                    type: 'none'
                },
                richText: {
                    textId: null
                }
            };
        case 'quill':
            var _legalTerms_richTextId;
            return {
                type: 'quill',
                legalTermsId: legalTerms.id,
                displayName: legalTerms.name,
                termsOfService: {
                    type: 'none'
                },
                quill: {
                    textId: (_legalTerms_richTextId = legalTerms.richTextId) !== null && _legalTerms_richTextId !== void 0 ? _legalTerms_richTextId : null
                },
                contentOverride: contentOverride ? {
                    type: 'custom',
                    custom: {
                        content: contentOverride
                    }
                } : {
                    type: 'none'
                }
            };
    }
}
